import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export function CuttingResultsCard({ results }) {
  return (
    <Card className="border-green-200 bg-green-50/50">
      <CardHeader><CardTitle className="text-green-700">Results - {results.file_name}</CardTitle></CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
          <div className="bg-white p-3 rounded border">
            <div className="text-2xl font-bold text-green-600">{results.summary.total_items_processed}</div>
            <div className="text-sm text-muted-foreground">Cuts Done</div>
          </div>
          <div className="bg-white p-3 rounded border">
            <div className="text-2xl font-bold text-orange-600">{results.summary.total_wastage_mm.toFixed(0)}mm</div>
            <div className="text-sm text-muted-foreground">Wastage</div>
          </div>
          <div className="bg-white p-3 rounded border">
            <div className="text-2xl font-bold text-blue-600">{results.summary.total_remnants_created}</div>
            <div className="text-sm text-muted-foreground">Remnants</div>
          </div>
          <div className="bg-white p-3 rounded border">
            <div className="text-2xl font-bold text-red-600">{results.summary.items_with_insufficient_stock}</div>
            <div className="text-sm text-muted-foreground">Shortages</div>
          </div>
        </div>
        <ResultsList results={results.results} />
      </CardContent>
    </Card>
  );
}

function ResultsList({ results }) {
  return (
    <div className="space-y-2">
      {results.map(function(r, idx) {
        var statusClass = r.status === 'completed' ? 'bg-white border-green-200' : r.status === 'partial' ? 'bg-yellow-50 border-yellow-200' : 'bg-red-50 border-red-200';
        var badgeClass = r.status === 'completed' ? 'bg-green-100 text-green-700' : r.status === 'partial' ? 'bg-yellow-100 text-yellow-700' : 'bg-red-100 text-red-700';
        return (
          <div key={idx} className={'p-3 rounded border ' + statusClass}>
            <div className="flex justify-between items-center">
              <span className="font-mono font-medium">{r.item_code}</span>
              <span className={'px-2 py-1 rounded text-xs ' + badgeClass}>{r.status}</span>
            </div>
            <div className="text-sm text-muted-foreground mt-1">
              {r.cuts_completed}/{r.cuts_requested} cuts - Wastage: {r.wastage_mm.toFixed(0)}mm
            </div>
          </div>
        );
      })}
    </div>
  );
}
